
import React, { Component } from 'react';
import services from '../../services';
import RightPopModalForm from './RightPopModalForm';
import $ from 'jquery'
const queryString = require('query-string');
var moment = require('moment')
const dateFormat = "YYYY-MM-DD";


class OpenAndCloseCashier extends Component {
    constructor() {
        super();
        this.state = {
            popUpForm: null,
            portoOpen: false,
            ReguaOpen: false,
            trans_methods: [],
            selectedLocation: window.localStorage.getItem('Local'),
            error: null,
        }
    }

    /* Carregar estado de página padrão  */

    defaultState = () => {
        this.setState({
            popUpForm: null,
            portoOpen: false,
            ReguaOpen: false,
            selectedLocation: window.localStorage.getItem('Local'),
            trans_methods: []
        }, () => this.getLastworkingDate())
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        this.getLastworkingDate();
        // this.getTransectionType();
    }

    componentDidUpdate = (preProp) => {
        if (preProp.date !== this.props.date) {
            this.defaultState();
        }
    }

    getLastworkingDate = async (forse = 0) => {
        let link = "/Revenue/LastWorkingDate";
        let res = await services.apiCall.requestApi(link, {});
        res = res || []
        this.openCashierFrom(res, forse);
        $(".modal-backdrop.show").css("display","none");
    }

    openCashierFrom = (res, forse) => {

        let portoOpen = false;
        let ReguaOpen = false;
        let popUpForm = null;
        let lastdata = {};

        res.map((row) => {
            if (row.caixa.toLowerCase() === 'porto' && parseInt(row.closed) === 0) {
                portoOpen = true
                window.localStorage.setItem('cashier_open', true);
                window.localStorage.setItem('cashier_open_date', row.date);
                lastdata.portodata = row;
            } else if (row.caixa.toLowerCase() === 'régua' && parseInt(row.closed) === 0) {
                ReguaOpen = true
                lastdata.reguadata = row;
                window.localStorage.setItem('cashier_open', true);
                window.localStorage.setItem('cashier_open_date', row.date);
            }
        });
        this.checkChashier();
        //console.log("RES",res);
        if (forse === 1 || !window.localStorage.getItem('cashier_open')) {
            popUpForm = (
                <RightPopModalForm
                    data={res}
                    lastdata={lastdata}
                    //previousDate={previousDate}
                    closePopup={this.closePopup}
                    tab={"Abertura"}
                    date={new Date()} />
            );
        }
        this.setState({
            popUpForm,
            portoOpen,
            ReguaOpen
        })

    }


    checkChashier=()=>{
        let cashier_open_value = window.localStorage.getItem('cashier_open');
        let cashier_open_value_date = window.localStorage.getItem('cashier_open_date');
        if (!cashier_open_value || moment(cashier_open_value_date).format(dateFormat) !== moment(new Date()).format(dateFormat)) {
            console.log("cashier_open_value", cashier_open_value);
            console.log("cashier_open_value_date", cashier_open_value_date);
           
            if (this.props.parsed.serviceNo !== 0) {
                this.props.updateParam();
                return 
            }
        }
    }


    openCashierbyDateFrom = (res, forse) => {

        let a = moment(new Date());
        let b = moment(res.date);
        let previousDate = false;
        let closed = false;
        let portoOpen = false;
        let ReguaOpen = false;
        let popUpForm = null;
        let lastdata = {};

        if (a.diff(b, 'days') > 0 && res.closed === 0) {
            previousDate = res.date;
        }

        res.map((row) => {
            if (row.caixa.toLowerCase() === 'porto' && parseInt(row.closed) === 0) {
                portoOpen = true
                window.localStorage.setItem('cashier_open', true);
                window.localStorage.setItem('cashier_open_date', row.date);
                lastdata.portodata = row;
            } else if (row.caixa.toLowerCase() === 'régua' && parseInt(row.closed) === 0) {
                ReguaOpen = true
                lastdata.reguadata = row;
                window.localStorage.setItem('cashier_open', true);
                window.localStorage.setItem('cashier_open_date', row.date);

            }
        })

        if (parseInt(res.closed) === 1) {
            closed = true;
            window.localStorage.setItem('cashier_open', "");
        } else {
            window.localStorage.setItem('cashier_open', true);
        }

        if (forse === 1 || (previousDate) || (!previousDate && !res.date)) {
            let popUpForm = (
                <RightPopModalForm
                    data={res}
                    lastData={lastdata}
                    previousDate={previousDate}
                    closePopup={this.closePopup}
                    tab={"Abertura"}
                    date={new Date()} />
            );
            this.setState({
                popUpForm
            })
        }

    }


    getTransectionType = async () => {

        let link = "Revenue/TransactionMethod/GetAll"
        const Request = { "Filters": null, "SortBy": "", "IsSortTypeDESC": false, "IsPagination": false, "Page": 1, "PageSize": 100 }
        let res = await services.apiCall.requestApi(link, Request);
        if (res) {
            this.setState({
                trans_methods: res
            })
        }

    }

    OpenTransectionMethods = (_row) => {
        let popUpForm = (
            <RightPopModalForm trans_methods={this.state.trans_methods} closePopup={this.closePopup} tab={_row} date={new Date()} />
        )
        this.setState({
            popUpForm
        })
    }

    updateselectedLocation = (Local) => {
        window.localStorage.setItem('Local', Local);
        this.setState({
            selectedLocation: Local
        })
    }

    /*  Para fechar pop-up  */
    closePopup = () => {
        this.getLastworkingDate();
        $(".left-popup").trigger('click');
    }

    /*  Para renderizar o conteúdo html da página   */

    render() {

        return (
            <div className="row" style={{ width: "450px" }}>
                <div className="col-md-6">
                    <div className="white-box">
                        <div className="d-flex justify-content-between">
                            <div className="flex-grow-1 mr-2">
                                <div className="dropdown custom-dropdown">
                                    <span className="cursor-pointer" data-toggle="modal" data-target="#openClose-modal" onClick={(e) => this.getLastworkingDate(1)}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <b>
                                                {
                                                    this.state.portoOpen || this.state.ReguaOpen ?
                                                        <div>Fechamento de Caixa</div> :
                                                        <div>Abertura de Caixa</div>
                                                }
                                            </b>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="white-box">

                        <div className="d-flex justify-content-between">
                            {/* <div className="flex-grow-1 mr-2">
                                <div className="dropdown custom-dropdown">
                                    <span>Local</span>
                                </div>
                            </div>  */
                            }

                            <div className="flex-grow-1 mr-2">
                                <div className="dropdown custom-dropdown">
                                    <span className="dropdown-toggle cursor-pointer" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{this.state.selectedLocation || "Local"} </span>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <ul className="list-unstyled">
                                            <li onClick={(val) => this.updateselectedLocation('Porto')}>
                                                {
                                                    this.state.portoOpen ?
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className="cursor-pointer">Porto Aberto</div>
                                                            <div><span className="cursor-pointer"><i className="fas fa-check-circle text-success"></i></span></div>
                                                        </div>
                                                        :
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className="cursor-pointer">Porto Fechado</div>
                                                            <div><span className="cursor-pointer"><i className="fas fa-times-circle text-danger"></i></span></div>
                                                        </div>

                                                }
                                                {/* <div className="d-flex justify-content-between align-items-center">
                                                    <div onClick={(val)=>this.updateselectedLocation('Porto')}>Porto</div>
                                                </div>  */
                                                }
                                            </li>
                                            <li onClick={(val) => this.updateselectedLocation('Régua')}>
                                                {
                                                    this.state.ReguaOpen ?
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>Régua Aberto</div>
                                                            <div><span className="cursor-pointer"><i className="fas fa-check-circle text-success"></i></span></div>
                                                        </div>
                                                        :
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div>Régua Fechado</div>
                                                            <div><span className="cursor-pointer"><i className="fas fa-times-circle text-danger"></i></span></div>
                                                        </div>

                                                }
                                                {/* <div className="d-flex justify-content-between align-items-center">
                                                    <div onClick={(val)=>this.updateselectedLocation('Régua')}>Régua</div>
                                                </div>  */
                                                }
                                            </li>

                                        </ul>

                                    </div>
                                </div>
                            </div>

                            <div className="flex-grow-1">
                                <div className="dropdown custom-dropdown">
                                    <span className="cursor-pointer" aria-haspopup="true" aria-expanded="false">
                                        {
                                            (!this.state.portoOpen && !this.state.ReguaOpen) || !this.state.selectedLocation ?
                                                "Fechado"
                                                :
                                                <>
                                                    {
                                                        this.state.selectedLocation === "Porto" && this.state.portoOpen && "Aberto"
                                                    }
                                                    {
                                                        this.state.selectedLocation === "Porto" && !this.state.portoOpen && "Fechado"
                                                    }
                                                    {
                                                        this.state.selectedLocation === "Régua" && this.state.ReguaOpen && "Aberto"
                                                    }
                                                    {
                                                        this.state.selectedLocation === "Régua" && !this.state.ReguaOpen && "Fechado"
                                                    }
                                                </>
                                        }
                                    </span>
                                </div>
                            </div>

                            {/* <div className="flex-grow-1 mr-2">
                                <div className="dropdown custom-dropdown">
                                    <span className="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Porto</span>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <ul className="list-unstyled">
                                            <li>
                                                {
                                                    this.state.portoOpen ?
                                                    <div className="d-flex justify-content-between align-items-center">
                                                    <div>Porto Aberto</div>
                                                    <div><span><i className="fas fa-check-circle text-success"></i></span></div>
                                                    </div>
                                                    :
                                                    <div className="d-flex justify-content-between align-items-center">
                                                    <div>Porto Fechado</div>
                                                    <div><span><i className="fas fa-times-circle text-danger"></i></span></div>
                                                    </div>

                                                }
                                            </li>
                                            <li>
                                                {
                                                    this.state.ReguaOpen ? 
                                                    <div className="d-flex justify-content-between align-items-center">
                                                    <div>Régua Aberto</div>
                                                    <div><span><i className="fas fa-check-circle text-success"></i></span></div>
                                                    </div>
                                                    :
                                                    <div className="d-flex justify-content-between align-items-center">
                                                    <div>Régua Fechado</div>
                                                    <div><span><i className="fas fa-times-circle text-danger"></i></span></div>
                                                </div>
                                                    
                                                }
                                               
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="flex-grow-1">
                                <div className="dropdown custom-dropdown">
                                    <span className="dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Aberto</span>
                                    <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <ul className="list-unstyled">
                                            <li data-toggle="modal" data-target="#openClose-modal" onClick={(e) => this.getLastworkingDate(1)}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>Abertura</div>
                                                </div>
                                            </li>
                                            <li data-toggle="modal" data-target="#openClose-modal" onClick={(e) => this.getLastworkingDate(1)}>
                                                {/* <li data-toggle="modal" data-target="#openClose-modal" onClick={(e) => this.OpenTransectionMethods('Fecho')}>  */
                            }
                            {/* <div className="d-flex justify-content-between align-items-center">
                                                    <div>Fecho</div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>   */
                            }
                        </div>
                    </div>
                </div>

                <div className="modal left-popup" id="openClose-modal">
                    <div className="modal-dialog modal-lg">
                        {
                            this.state.popUpForm
                        }
                    </div>
                </div>

            </div>
        );
    }
}

export default OpenAndCloseCashier;